<template>
  <CommonPages id="blog-detail" :classs="['blog-detail']" :titlePrefix="pageMetaTitle"
    :metaDescription="pageMetaDescription">
    <div class="blog-detail__container">
      <section class="blog-detail__baseinfo">
        <div class="blog-detail__left">
          <a class="blog-detail__back" :href="backHref" @click.prevent="goBack">
            <img src="@/assets/default/arrow-right-small.svg" alt="back" />
            <span>Back</span>
          </a>
          <p class="blog-detail__date">{{ blogData.date }}</p>
        </div>
        <div class="blog-detail__share">
          <span>Welcome blog, share on</span>
          <a href="javascript:void(0)" aria-label="share x" @click.prevent="copyCurrentUrl"><img
              src="@/assets/default/x-icon.svg" alt="x" /></a>
          <a href="javascript:void(0)" aria-label="share facebook"
            @click.prevent="copyCurrentUrl"><img src="@/assets/default/facebook-icon.svg"
              alt="facebook" /></a>
          <a href="javascript:void(0)" aria-label="share instagram"
            @click.prevent="copyCurrentUrl"><img src="@/assets/default/instagram-icon.svg"
              alt="instagram" /></a>
          <span v-if="copyToastText" class="blog-detail__share-toast">{{ copyToastText }}</span>
        </div>
      </section>

      <div v-if="blogAds.headerBelow" class="blog-detail__ad-wrap">
        <AdComponent class="ad-width-100" :ads="blogAds.headerBelow" :showDebug="showDebug"
          :forceDebug="true" debugLabel="blog_ad_1_header_below" debugPosition="Blog 头部信息下方" />
      </div>

      <h1 class="blog-detail__title">{{ blogData.title }}</h1>
      <div v-if="deviceType == 'mobile' && blogAds.titleBelowMobile" class="blog-detail__ad-wrap">
        <AdComponent class="ad-width-100" :ads="blogAds.titleBelowMobile" :showDebug="showDebug"
          :forceDebug="true" debugLabel="blog_ad_2_m_title_below" debugPosition="Blog 标题下方（移动端）" />
      </div>

      <section class="blog-detail__article">
        <p class="blog-detail__lead">{{ blogData.lead }}</p>
        <div v-if="deviceType == 'mobile' && blogAds.leadBelowMobile" class="blog-detail__ad-wrap">
          <AdComponent class="ad-width-100" :ads="blogAds.leadBelowMobile" :showDebug="showDebug"
            :forceDebug="true" debugLabel="blog_ad_3_m_lead_below" debugPosition="Blog 导语下方（移动端）" />
        </div>
        <template v-for="(section, index) in blogData.sections">
          <h2 class="blog-detail__h2" :key="`${section.title}-t`">{{ section.title }}</h2>
          <p class="blog-detail__p" :key="`${section.title}-p`">{{ section.body }}</p>
          <div v-if="deviceType != 'mobile' && index === 0 && blogAds.pcMid"
            :key="`${section.title}-ad-pc`" class="blog-detail__ad-wrap blog-detail__ad-wrap--pc">
            <AdComponent class="ad-width-100" :ads="blogAds.pcMid" :showDebug="showDebug"
              :forceDebug="true" debugLabel="blog_ad_4_pc_mid" debugPosition="Blog 正文中段（仅PC）" />
          </div>
          <div v-if="deviceType == 'mobile' && index === 1 && blogAds.mobileMid"
            :key="`${section.title}-ad-m`" class="blog-detail__ad-wrap">
            <AdComponent class="ad-width-100" :ads="blogAds.mobileMid" :showDebug="showDebug"
              :forceDebug="true" debugLabel="blog_ad_5_m_mid" debugPosition="Blog 正文中段（移动端）" />
          </div>
        </template>
        <div class="blog-detail__hero" :style="{ backgroundImage: `url(${blogData.heroImage})` }">
        </div>
        <div v-if="deviceType == 'mobile' && blogAds.heroBelowMobile" class="blog-detail__ad-wrap">
          <AdComponent class="ad-width-100" :ads="blogAds.heroBelowMobile" :showDebug="showDebug"
            :forceDebug="true" debugLabel="blog_ad_6_m_hero_below" debugPosition="Blog 大图下方（移动端）" />
        </div>
        <template v-for="section in blogData.sectionsAfterImage">
          <h2 class="blog-detail__h2" :key="`${section.title}-at`">{{ section.title }}</h2>
          <p class="blog-detail__p" :key="`${section.title}-ap`">{{ section.body }}</p>
        </template>
      </section>
    </div>

    <div v-if="blogAds.pagerAbove" class="blog-detail__ad-wrap blog-detail__ad-wrap--footer">
      <AdComponent class="ad-width-100" :ads="blogAds.pagerAbove" :showDebug="showDebug"
        :forceDebug="true" debugLabel="blog_ad_7_pager_above" debugPosition="Blog 翻页区域上方" />
    </div>

    <section class="blog-detail__pager">
      <a class="blog-detail__pager-item blog-detail__pager-item--left"
        :href="getPageUrl(`/blog/${prevBlog.id}?city=${citySlug}`)">
        <i class="blog-detail__pager-icon blog-detail__pager-icon--left"></i>
        <span class="blog-detail__pager-text">{{ prevBlog.title }}</span>
      </a>
      <a class="blog-detail__pager-item blog-detail__pager-item--right"
        :href="getPageUrl(`/blog/${nextBlog.id}?city=${citySlug}`)">
        <span class="blog-detail__pager-text">{{ nextBlog.title }}</span>
        <i class="blog-detail__pager-icon"></i>
      </a>
    </section>
  </CommonPages>
</template>

<script>
import CommonPages from '@/pages/components/page_common.vue';
import { mapGetters } from 'vuex';
import AdComponent from '@/pages/components/AdComponent.vue';
import adMixin from '@/mixin/adMixin.js';
import adTrackingMixin from '@/mixin/adTrackingMixin.js';
import { getContentTextMap, getText } from '@/utils/contentText';
import { createAdVariantOrNull, getRenderableAd } from '@/utils/adConfig';

const PLACEHOLDER_IMAGE = require('@/assets/default/quote-bg.jpg');

function slugToTitle (slug) {
  return (slug || 'what-makes-a-city-truly-livable')
    .split('-')
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
}

const DEFAULT_BLOG = {
  date: 'JANUARY 27, 2026',
  title: 'What Makes a City Truly Livable?',
  metaDescription: 'Learn what defines a livable city through affordability, safety, healthcare, transport and sustainability.',
  lead:
    'When people talk about livable cities, they often think of clean streets and efficient transit. True livability goes further: it means a city supports stable, meaningful daily life.',
  sections: [
    {
      title: 'Affordability and Cost of Living',
      body: 'A city is not livable if residents cannot sustain basic needs. Strong cities align local income with housing, food, transport, and healthcare costs while preserving economic opportunity.'
    },
    {
      title: 'Safety and Personal Security',
      body: 'Livability requires trust in daily movement and public order. Crime prevention, lighting, road safety, and responsive services all shape the lived experience.'
    },
    {
      title: 'Healthcare and Wellbeing',
      body: 'Reliable medical access, preventive care, and healthier built environments directly improve long-term quality of life for residents.'
    }
  ],
  sectionsAfterImage: [
    {
      title: 'Transportation and Accessibility',
      body: 'Integrated transit and inclusive design reduce daily friction and connect residents to education, work, and services.'
    },
    {
      title: 'Employment and Economic Stability',
      body: 'Diverse job markets and resilient local economies help residents plan long-term and remain confident in city life.'
    },
    {
      title: 'Education and Personal Growth',
      body: 'A livable city supports schools, libraries, culture, and lifelong learning to foster social mobility and innovation.'
    },
    {
      title: 'Culture, Identity, and Community',
      body: 'Strong identity and social belonging come from local culture, inclusive policies, and meaningful public spaces.'
    },
    {
      title: 'Environmental Sustainability',
      body: 'Cities must address climate resilience, air quality, and resource use to remain truly livable in the long run.'
    },
    {
      title: 'Measuring Livability',
      body: 'No single score defines livability. Data matters, but personal priorities and life stage shape how each person evaluates a city.'
    },
    {
      title: 'Choosing the Right City for You',
      body: 'The best city depends on your work, family needs, and lifestyle. Use rankings as a reference, then evaluate daily practicality.'
    }
  ],
  heroImage: PLACEHOLDER_IMAGE
};

export default {
  name: 'BlogDetailPage',
  components: {
    CommonPages,
    AdComponent
  },
  mixins: [adMixin, adTrackingMixin],
  data () {
    return {
      copyToastText: '',
      copyToastTimer: null,
    };
  },
  computed: {
    ...mapGetters(['livableCityData', 'adsensConfig', 'showDebug', 'deviceType', 'domainConfig']),
    contentText () {
      return getContentTextMap(this.domainConfig);
    },
    pageMetaTitle () {
      return getText(this.contentText, 'BLOG_META_TITLE', this.blogData.title);
    },
    pageMetaDescription () {
      return getText(this.contentText, 'BLOG_META_DESCRIPTION', 'Exploring the evolving landscape of global living. From sustainable design trends to the rise of digital nomad hubs, stay informed with our deep dives into modern urbanity.') || this.blogData.metaDescription;
    },
    blogSlug () {
      return (this.$route.params.slug || 'what-makes-a-city-truly-livable').toLowerCase();
    },
    citySlug () {
      return (this.$route.query.city || 'tokyo').toLowerCase();
    },
    backHref () {
      return this.getPageUrl('/');
    },
    blogList () {
      return this.livableCityData.blogs || [];
    },
    currentIndex () {
      const bySlug = this.blogList.findIndex((item) => item.slug === this.blogSlug);
      if (bySlug >= 0) {
        return bySlug;
      }
      const byId = this.blogList.findIndex((item) => String(item.id) === this.blogSlug);
      return byId >= 0 ? byId : 0;
    },
    prevBlog () {
      if (!this.blogList.length) {
        return { id: 1, slug: '', title: '' };
      }
      const index = (this.currentIndex - 1 + this.blogList.length) % this.blogList.length;
      return this.blogList[index];
    },
    nextBlog () {
      if (!this.blogList.length) {
        return { id: 1, slug: '', title: '' };
      }
      const index = (this.currentIndex + 1) % this.blogList.length;
      return this.blogList[index];
    },
    currentImage () {
      const cities = this.livableCityData.cities || [];
      if (!cities.length) {
        return PLACEHOLDER_IMAGE;
      }
      const seed = this.blogSlug.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
      const city = cities[seed % cities.length];
      return city.image || PLACEHOLDER_IMAGE;
    },
    blogData () {
      const listMatched = this.blogList[this.currentIndex];
      const hasFullContent = listMatched && listMatched.sections && listMatched.sections.length > 0;

      if (hasFullContent) {
        return {
          ...DEFAULT_BLOG,
          title: listMatched.title,
          date: listMatched.date,
          lead: listMatched.lead || DEFAULT_BLOG.lead,
          sections: listMatched.sections || DEFAULT_BLOG.sections,
          sectionsAfterImage: listMatched.sectionsAfterImage || DEFAULT_BLOG.sectionsAfterImage,
          heroImage: listMatched.heroImage === null ? this.currentImage : (listMatched.heroImage || DEFAULT_BLOG.heroImage),
          metaDescription: listMatched.metaDescription || `Read ${listMatched.title} and discover how city livability is evaluated.`
        };
      }

      const title = listMatched?.title || slugToTitle(this.blogSlug);
      const date = listMatched?.date || DEFAULT_BLOG.date;
      return {
        ...DEFAULT_BLOG,
        title,
        date,
        metaDescription:
          !listMatched
            ? DEFAULT_BLOG.metaDescription
            : `Read ${title} and discover how city livability is evaluated.`,
        heroImage: this.currentImage
      };
    },
    blogAds () {
      const base = getRenderableAd(this.adsensConfig?.home_ad || this.adsensConfig?.home_1);
      return {
        headerBelow: createAdVariantOrNull(base, 'blog-header-below'),
        titleBelowMobile: createAdVariantOrNull(base, 'blog-title-mobile'),
        leadBelowMobile: createAdVariantOrNull(base, 'blog-lead-mobile'),
        pcMid: createAdVariantOrNull(base, 'blog-pc-mid'),
        mobileMid: createAdVariantOrNull(base, 'blog-mobile-mid'),
        heroBelowMobile: createAdVariantOrNull(base, 'blog-hero-mobile'),
        pagerAbove: createAdVariantOrNull(base, 'blog-pager-above')
      };
    }
  },
  methods: {
    showCopyToast (text) {
      this.copyToastText = text;
      if (this.copyToastTimer) {
        clearTimeout(this.copyToastTimer);
      }
      this.copyToastTimer = setTimeout(() => {
        this.copyToastText = '';
        this.copyToastTimer = null;
      }, 1800);
    },
    goBack () {
      if (typeof window === 'undefined') {
        return;
      }
      if (window.history.length > 1) {
        window.history.back();
        return;
      }
      window.location.href = this.backHref;
    },
    async copyCurrentUrl () {
      if (typeof window === 'undefined') {
        return;
      }
      const url = window.location.href;
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(url);
        } else {
          const input = document.createElement('input');
          input.value = url;
          document.body.appendChild(input);
          input.select();
          document.execCommand('copy');
          document.body.removeChild(input);
        }
        console.log('[BlogDetail] URL copied');
        this.showCopyToast('Link copied');
      } catch (error) {
        console.error('[BlogDetail] copy failed', error);
        this.showCopyToast('Copy failed');
      }
    },
    getPageUrl (path) {
      if (this.$route.params.channel) {
        return `/${this.$route.params.channel}${path}`;
      }
      return path;
    }
  },
  beforeDestroy () {
    if (this.copyToastTimer) {
      clearTimeout(this.copyToastTimer);
      this.copyToastTimer = null;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~@/css/variables.scss';

.blog-detail {
	background: $color-bg-cream;

	&__container {
		max-width: rem(1080);
		padding: rem(40) rem(20) rem(60);
		margin: 0 auto;
	}

	&__ad-wrap {
		margin: rem(16) 0;
	}

	&__ad-wrap--footer {
		max-width: rem(1080);
		padding: 0 rem(20);
		margin: 0 auto rem(20);
		box-sizing: border-box;
	}

	&__baseinfo {
		display: flex;
		flex-direction: column;
		gap: rem(16);
	}

	&__left {
		display: inline-flex;
		align-items: center;
		gap: rem(16);
	}

	&__back {
		display: inline-flex;
		align-items: center;
		gap: rem(8);
		padding: rem(8) rem(16);
		border-radius: rem(100);
		background: #fecd45;
		text-decoration: none;
		color: #000;
		font-size: rem(16);

		img {
			width: rem(16);
			height: rem(16);
			transform: rotate(180deg);
		}
	}

	&__date {
		margin: 0;
		font-size: rem(16);
		font-style: italic;
	}

	&__share {
		display: inline-flex;
		align-items: center;
		flex-wrap: wrap;
		gap: rem(12);
		font-size: rem(16);
		font-style: italic;

		a {
			display: inline-flex;
			align-items: center;
		}

		img {
			width: rem(20);
			height: rem(20);
		}
	}

	&__share-toast {
		padding: rem(6) rem(12);
		border-radius: rem(999);
		background: rgba(0, 0, 0, 0.84);
		color: #fff;
		font-size: rem(14);
		line-height: rem(18);
		font-style: normal;
	}

	&__title {
		margin: rem(24) 0 rem(40);
		font-size: rem(44);
		line-height: rem(56);
	}

	&__article {
		display: flex;
		flex-direction: column;
		gap: rem(24);
	}

	&__lead,
	&__p {
		margin: 0;
		font-size: rem(16);
		line-height: rem(24);
	}

	&__h2 {
		margin: 0;
		font-size: rem(20);
		line-height: rem(24);
		font-weight: 700;
	}

	&__hero {
		height: rem(320);
		border-radius: rem(24);
		border: 1px solid rgba(0, 0, 0, 0.1);
		background-size: cover;
		background-position: center;
	}

	&__pager {
		border-top: 1px solid rgba(0, 0, 0, 0.1);
		display: flex;
		flex-direction: column;
		gap: rem(20);
		padding: rem(20) rem(20) rem(60);
	}

	&__pager-item {
		display: flex;
		align-items: center;
		gap: rem(16);
		color: #000;
		text-decoration: underline;
		font-size: rem(20);
		line-height: rem(24);
		font-weight: 700;

		&--right {
			justify-content: flex-end;
			text-align: right;
		}
	}

	&__pager-text {
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 3;
		overflow: hidden;
	}

	&__pager-icon {
		width: rem(40);
		height: rem(40);
		border-radius: 50%;
		background: #fecd45;
		position: relative;
		flex-shrink: 0;

		&::after {
			content: '';
			position: absolute;
			left: 50%;
			top: 50%;
			width: rem(10);
			height: rem(10);
			border-top: 1px solid #000;
			border-right: 1px solid #000;
			transform: translate(-60%, -50%) rotate(45deg);
		}

		&--left::after {
			transform: translate(-40%, -50%) rotate(-135deg);
		}
	}
}

.detect_deviece_mobile {
	.blog-detail {
		&__pager {
			flex-direction: row;
			justify-content: space-between;
			align-items: flex-start;
			gap: rem(24);
		}

		&__pager-item {
			width: calc(50% - #{rem(12)});
			align-items: flex-start;
		}

		&__pager-item--left {
			flex-direction: column-reverse;
		}

		&__pager-item--right {
			flex-direction: column;
			align-items: flex-end;
		}

		&__pager-icon {
			margin-top: rem(4);
		}
	}
}

.detect_deviece_pc,
.detect_deviece_desktop {
	.blog-detail {
		&__container {
			max-width: none;
			padding: rem(40) rem(180) rem(60);
		}

		&__baseinfo {
			flex-direction: row;
			justify-content: space-between;
			align-items: center;
		}

		&__pager-item {
			flex-direction: row;
			align-items: center;
			width: rem(440);
		}

		&__pager-item--left {
			flex-direction: row;
		}

		&__pager-item--right {
			flex-direction: row;
		}

		&__pager {
			padding: rem(20) rem(180) rem(60);
		}

		&__pager-icon {
			margin-top: 0;
		}
	}
}
</style>
